export default {
  MapBoxToken: process.env.PUBLIC_MAPBOX_API_TOKEN ?? 'pk.eyJ1IjoidG9iaS1sYXVlciIsImEiOiJja2JueTN0OW8xM29yMnVyNXluYmo3dzhuIn0.hzuqYksU8etABg1Og67N2g',
 }